import React from "react";
import CurrencyFormat from "react-currency-format";
import { useCurrencyConversion } from "../../../../jsx/hooks/useCurrency";

const formatAmount = (val, decimals = 2) =>
	val.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: decimals });

const SYMBOLS = { FCFA: "FCFA", Euro: "€", USD: "$", DOLLAR: "$" };

/**
 * Affiche un montant avec conversion.
 *
 * @param {number} value - Montant à afficher (dans sourceCurrency)
 * @param {string} sourceCurrency - "FCFA" | "Euro" | "USD" - devise de la valeur (défaut: "FCFA")
 * @param {boolean} primaryFcfa - Si true, affiche FCFA en premier (converti depuis la devise source). Pour factures: on détecte la devise et on convertit en FCFA.
 * @param {boolean} showConversion - Afficher les conversions (défaut: true)
 * @param {boolean} showUsd - Afficher l'équivalent USD si pertinent (défaut: true)
 * @param {string} prefix - Préfixe optionnel
 */
function Currency(props) {
	const { currency, convert } = useCurrencyConversion();
	const {
		value: rawValue = 0,
		sourceCurrency = "FCFA",
		primaryFcfa = false,
		showConversion = true,
		showUsd = true,
		prefix = ""
	} = props;

	const value = parseFloat(rawValue) || 0;
	const src = sourceCurrency === "DOLLAR" ? "USD" : sourceCurrency;

	// Quand primaryFcfa: on convertit vers FCFA et on affiche FCFA en premier, original en secondaire
	const userCurrency = currency === "DOLLAR" ? "USD" : (currency || "FCFA");
	const fcfaValue = src !== "FCFA" ? convert(value, src, "FCFA") : value;

	let primaryValue, primarySymbol, secondaryValue, secondarySymbol;
	if (primaryFcfa && src !== "FCFA") {
		primaryValue = Math.round(fcfaValue * 100) / 100;
		primarySymbol = "FCFA";
		secondaryValue = Math.round(value * 10000) / 10000;
		secondarySymbol = SYMBOLS[src] || src;
	} else {
		primaryValue = Math.round(value * (src === "FCFA" ? 100 : 10000)) / (src === "FCFA" ? 100 : 10000);
		primarySymbol = SYMBOLS[src] || src;
		secondaryValue = userCurrency !== src ? convert(value, src, userCurrency) : null;
		secondarySymbol = SYMBOLS[userCurrency] || userCurrency;
	}

	const usdValue = showUsd && src !== "USD" ? convert(value, src, "USD") : null;

	return (
		<span style={{ whiteSpace: "nowrap" }}>
			{prefix}
			<CurrencyFormat
				value={primaryValue}
				displayType="text"
				thousandSeparator=" "
				decimalScale={2}
				fixedDecimalScale={false}
				suffix={` ${primarySymbol}`}
			/>
			{showConversion && secondaryValue != null && (
				<small style={{ marginLeft: 6, opacity: 0.9 }}>
					({formatAmount(secondaryValue, secondarySymbol === "€" ? 2 : 0)} {secondarySymbol})
				</small>
			)}
			{showConversion && showUsd && usdValue != null && (
				<small style={{ marginLeft: 6, opacity: 0.85 }}>
					({formatAmount(usdValue, 2)} $)
				</small>
			)}
		</span>
	);
}

export default Currency; 
